import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate }) => {
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                d: Math.floor(difference / (1000 * 60 * 60 * 24)),
                h: Math.floor((difference / (1000 * 60 * 60)) % 24),
                m: Math.floor((difference / 1000 / 60) % 60),
                s: Math.floor((difference / 1000) % 60),
            };
        } else {
            return null; // Timer expired
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    if (!timeLeft) {
        return <span className="text-red-500 font-bold text-sm">Batch Started!</span>;
    }

    const format = (num) => num.toString().padStart(2, '0');

    return (
        <div className="flex gap-2 text-sm font-mono text-orange-500 font-bold items-center mt-2">
            <span className="animate-pulse">⏳ Filling Fast:</span>
            <span>
                {timeLeft.d}d : {format(timeLeft.h)}h : {format(timeLeft.m)}m : {format(timeLeft.s)}s
            </span>
        </div>
    );
};

export default CountdownTimer;
